// src/functions/rndm_utils/utils.ts
function alertit(obj = null) {
    let msg;
    try {
        msg = JSON.stringify(obj);
    }
    catch {
        // If JSON.stringify fails (circular refs, etc.), fall back to a simple string
        msg = String(obj);
    }
    alert(msg);
}

export { alertit };
//# sourceMappingURL=utils.js.map
